import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AdminService } from '@appShared/services/admin.service';
import { ShareholderService } from '@appShared/services/shareholder.service';
import { AdminApiActions, AdminPageActions } from '@appState/actions/admin';

@Injectable()
export class AdminEffects {
  constructor(
    private _actions$: Actions,
    private _adminService: AdminService,
    private _shareholderService: ShareholderService
  ) {}

  // loadShareholders$ = createEffect(() => {
  //  return this._actions$.pipe(
  //    ofType(AdminPageActions.loadShareholder),
  //    switchMap(action =>
  //      this._shareholderService
  //        .getShareholder(action.id)
  //        .pipe(
  //          map(shareholder =>
  //            AdminApiActions.loadShareholderSuccess({ shareholder })
  //          ),
  //          catchError(error =>
  //            of(AdminApiActions.loadShareholderFailure({ error }))
  //          )
  //        )
  //    )
  //  );
  // });
}
